import { useThrottle } from '@react-hook/throttle';
import { useQuery } from '@tanstack/react-query';
import useDeepCompareEffect from 'use-deep-compare-effect';

import { apiClient } from 'api/ApiClient';
import type { GetMembersParams } from 'api/types';
import { useAuth } from 'shared/lib/auth/useAuth';

import { QueryKeys } from './QueryKeys';
import { isNotApproved } from '../lib/tools';

export const useGetMembers = (params: GetMembersParams, enabled = true) => {
  const [throttledParams, setThrottledParams] = useThrottle(params, 3);

  useDeepCompareEffect(() => {
    setThrottledParams(params);
  }, [params]);

  return useQuery({
    queryKey: [QueryKeys.GetMembers, throttledParams],
    queryFn: () => apiClient.getMembers(throttledParams),
    enabled,
  });
};

export const useGetNotApprovedMembers = () => {
  const { permissions } = useAuth();
  const enabled = permissions.has('can_invite_users') && permissions.has('can_view_company_settings');

  return useQuery({
    queryKey: [QueryKeys.GetMembers, { is_approved: 'null', page_size: 300 }],
    queryFn: () => apiClient.getMembers({ is_approved: 'null', page_size: 300 }),
    select: (data) => data.results.filter(isNotApproved),
    enabled,
  });
};
